<template lang="jade">
  template(v-if="form | isView")
    div.Container(v-for="coll in fdata.rows")
      div.Display(v-for="item in coll"
                  class="Display--input")
        strong.Display__label {{{ fdata.templates[$index].label }}}:
        span.Display__text {{{ item | format fdata.templates[$index]}}}
  template(v-else)  
    table(class="Table")
      thead(class="Table__header")
        tr(class="Table__row Table__row--columns")
          th(v-for="col in fdata.columns"
            class="Table__column") {{{ col }}}
      tbody(class="Table__body")
        tr(v-for="row in fdata.rows"
          class="Table__row Table__row--cells")
          td(v-for="cell in row"
            class="Table__cell") {{{ cell | format }}}
</template>

<script>
import Moment from 'moment'
import _ from 'lodash'
import {forms, skins} from 'src/vuex/getters'

export default {
  data () {
    return {
      uid: this.$parent.uid
    }
  },
  props: {
    fdata: {
      type: Object,
      coerce: (x) => {
        let columns = x.templates.map(xs => xs.label)
        let data = x.templates.map(xs => x.data[xs.field])
        let numRows = _.head(data).length
        let numCols = data.length
        let rows = _.times(numRows, idx => _.times(numCols, n => {
          return !_.isUndefined(data[n][idx]) && _.has(data[n][idx], 'value') ? data[n][idx].value : ''
        }))
        return Object.assign(x, {columns, rows})
      },
      required: true
    }
  },
  vuex: {
    getters: {
      forms,
      skins
    }
  },
  computed: {
    form () {
      return _.find(this.forms, ['uid', this.uid])
    }
  },
  filters: {
    format (str, schema) {
      if (_.has(schema, 'type') && schema.type === 'type_select') {
        return _.find(schema.options, ['value', str]).label
      }
      /* eslint-disable no-useless-escape */
      if (/^((31(?!\ (Feb(ruary)?|Apr(il)?|June?|(Sep(?=\b|t)t?|Nov)(ember)?)))|((30|29)(?!\ Feb(ruary)?))|(29(?=\ Feb(ruary)?\ (((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)))))|(0?[1-9])|1\d|2[0-8])\ (Jan(uary)?|Feb(ruary)?|Ma(r(ch)?|y)|Apr(il)?|Ju((ly?)|(ne?))|Aug(ust)?|Oct(ober)?|(Sep(?=\b|t)t?|Nov|Dec)(ember)?)\ ((1[6-9]|[2-9]\d)\d{2})$/.test(str)) {
        return Moment(str).format('DD/MM/YYYY')
      } else if (/<\/?[a-z][\s\S]*>/i.test(str)) {
        return str.replace('&newline;')
      } else if (this.skins.app === 'sovereign') {
        return _.capitalize(str.toLowerCase())
      } else {
        return str
      }
    },
    isView (x) {
      return _.includes(['MEMBERSHIP.JOL.CONFIRM', 'MY.PLAN.VIEW', 'PARTNER.CONFIRM'], x.uid.split('_')[0])
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?bd2a218c